import { Link } from "react-router";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";
import { shouldForwardProp } from "theme/utils";

type ItemProps = {
  $selected: boolean;
  $disabled?: boolean;
};

export const StyledItem = styled(Link, { shouldForwardProp })<ItemProps>`
  display: flex;
  position: relative;
  padding: 0.8125rem 0.9375rem;
  border-radius: 0.325rem;
  margin-bottom: 0.625rem;
  align-self: stretch;
  align-items: center;

  ${(props) =>
    props.$selected &&
    css`
      box-shadow: 0 0.59rem 1.175rem 0 rgba(0, 0, 0, 0.2);
      background-color: ${Colors.WHITE};
    `}

  text-decoration: none;

  cursor: pointer;
  font-size: 1.25rem;
  ${fontQuicksand()};
  font-weight: 500;

  color: ${Colors.PURPLE};
  &:hover {
    color: ${Colors.LIGHT_PURPLE};
  }

  ${(props) =>
    props.$disabled &&
    css`
      pointer-events: none;
      color: ${Colors.TEXT_GRAY};
    `}
`;
